import React, { PropsWithChildren } from 'react'

import { Loading } from '../../../../global/Loading/Loading'
import { FullPageModalMobile } from '../FullPageModalMobile'
import { CommonModalProps, CommonModalTitleProps } from '../types'

interface PageModalProps extends PropsWithChildren<CommonModalTitleProps & CommonModalProps> {
  renderFooter?(props: PageModalProps): React.ReactNode[]
  goBack?(): void
}

export const PageModalMobile: React.FC<PageModalProps> = (props) => {
  const { title, children, renderFooter, isLoading = false, goBack, onClose } = props

  return (
    <FullPageModalMobile
      title={title}
      renderFooter={renderFooter}
      goBack={goBack}
      onClose={onClose}
    >
      <Loading isLoading={isLoading} showLoadingIcon>
        {children}
      </Loading>
    </FullPageModalMobile>
  )
}
